<div class="row">
  <div class="col-md-12">
    <div class="row mt-4">
      <div class="col-auto pr-0">
        <div #newImage (click)="openNewWrapper()">
          <button class="btn-add-bd">
            <img class="no-image" src='assets/ph-bhp-configuration/svg/icon-plus.svg'>
            <span>{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }} </span>
          </button>
          <!-- <div class="card-task-media addNew">
            <img class="no-image" src='assets/ph-bhp-configuration/svg/icon-plus.svg'>
            <span>{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }}</span>
          </div> -->
        </div>
      </div>
      <div #cdkDragList class="col-auto pr-0" *ngFor="let image of ImageData;let i = index">
        <div class="card-task card-task-small" (click)="openWrapper(i)">
          <div class="card-task-media">
            <img class="imgFilter" [src]='serverUrl+image.imageURL'>
          </div>
        </div>
      </div>
    </div>

    <div class="define-sop-wrapper" #sopWrapper [hidden]="!collapseExample" id="collapseExample">
      <form class="form-container" [formGroup]="addImageInstitutionForm" class="form-container imageLibraryContain"
        name="addImageInstitutionForm" #ngForm="ngForm">
        <div class="define-single-sop">
          <span #arrw class="arrw"></span>
          <span #arrwShadow class="arrwShadow"></span>
          <div class="m-4">
            <div class="row">
              <div class="col-md-3 col-sm-12" style="display: flex; flex-direction: column;">
                <div class="form-group image-input">
                  <mat-form-field class="example-full-width">
                    <mat-label> {{ 'CONFIGURE.IMAGE_NAME' | translate }} </mat-label>
                    <input matInput inputSanitizer type="text" formControlName="imageName" class="form-control"
                      (input)="canWriteOnInput($event, imagenamelength)"
                      maxLength="imagenamelength" name="imageName" formControlName="imageName" id="imageName" required
                      [ngClass]="{'is-invalid':addImageInstitutionForm.get('imageName').errors && (addImageInstitutionForm.get('imageName').touched || addImageInstitutionForm.get('imageName').dirty || ngForm.submitted)}">
                  </mat-form-field>
                  <mat-hint class="max-value-hint" align="end">
                    {{ (addImageInstitutionForm.get('imageName').value) ? (addImageInstitutionForm.get('imageName').value.length < imagenamelength ? addImageInstitutionForm.get('imageName').value.length : imagenamelength) : 0 }}
                    /
                    {{imagenamelength}}</mat-hint>
                  <div class="form-control-descrition-msgs">
                    <div class="invalid-feedback"
                      *ngIf="addImageInstitutionForm.get('imageName').errors && (addImageInstitutionForm.get('imageName').touched ||addImageInstitutionForm.get('imageName').dirty || ngForm.submitted)">
                      <span *ngIf="addImageInstitutionForm.get('imageName').errors.required">
                        {{ 'ERROR_MESSAGES.REQUIRED.IMAGE_NAME' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
                <form>
                  <div class="form-group image-input">
                    <mat-form-field class="example-full-width">
                      <mat-label>{{ 'CONFIGURE.TAGS' | translate }}</mat-label>
                      <input #tagInput (keyup.enter)="onInputTagKeyup($event.target)" matInput type="text"
                        class="form-control" />
                    </mat-form-field>
                    <br>
                    <mat-chip-list aria-label="Fish selection">
                      <mat-chip [selectable]="true" (click)="remove(item)" *ngFor="let item of items" [removable]="true"
                        [color]="">{{item.value}} ⓧ</mat-chip>
                    </mat-chip-list>
                  </div>
                </form>
              </div>
              <div class="col-md-3 col-sm-12">
                <div class="form-group">
                  <mat-form-field class="example-full-width">
                    <mat-label> {{ 'CONFIGURE.DESCRIPTION' | translate }} </mat-label>
                    <input matInput inputSanitizer type="text" formControlName="description" class="form-control"
                      maxLength="imageLibDescriptionMaxlength" name="description" formControlName="description"
                      id="description" required
                      (input)="canWriteOnInput($event, imageLibDescriptionMaxlength)"
                      [ngClass]="{'is-invalid':addImageInstitutionForm.get('description').errors && (addImageInstitutionForm.get('description').touched || addImageInstitutionForm.get('description').dirty || ngForm.submitted)}">
                  </mat-form-field>
                  <mat-hint class="max-value-hint" align="end">
                    {{ (addImageInstitutionForm.get('description').value) ? (addImageInstitutionForm.get('description').value.length < imageLibDescriptionMaxlength ? addImageInstitutionForm.get('description').value.length : imageLibDescriptionMaxlength) : 0 }}
                    /
                    {{imageLibDescriptionMaxlength}}</mat-hint>
                  <div class="form-control-descrition-msgs">
                    <div class="invalid-feedback"
                      *ngIf="addImageInstitutionForm.get('description').errors && (addImageInstitutionForm.get('description').touched ||addImageInstitutionForm.get('description').dirty || ngForm.submitted)">
                      <span *ngIf="addImageInstitutionForm.get('description').errors.required">
                        {{ 'ERROR_MESSAGES.REQUIRED.DESCRIPTION' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-12">

              </div>
              <div class="col-md-3 col-sm-12">
                <div class="row" style="justify-content: end;">
                  <div class="col-12 image-section">
                    <div class="row" accept="image/*">
                      <div class="uploadBtnAlign card_image col-12 d-flex justify-content-center align-items-center"
                        [ngClass]="{'is-invalid  form-control':( !imageURL && ngForm.submitted)}">
                        <div class="upload-button">
                          <img [ngClass]="imageURL?'svg img-fluid img-card-top':'no-image'"
                            [src]="imageURL?(isPreview?'':serverUrl)+imageURL:'assets/ph-bhp-layout/svg/FileUploadOutlined.svg'">
                          <p class="text-center text-upload" *ngIf="!imageURL">{{ 'CONFIGURE.UPLOAD_IMAGE' | translate
                            }}</p>
                          <input #newfile type="file" class="btn btn-link btn-block"
                            accept="image/x-png,image/png,image/jpeg" FormControlName="imageURL"
                            (change)="preview(newfile.files)" />
                        </div>
                      </div>
                    </div>
                    <div class="text-section p-0">
                      <div class="col-12 p-0">
                        <p class="info-text" *ngFor="let text of formatTexts">
                          {{ text }}
                        </p>
                        <p class="info-text">{{ 'CONFIGURE.IMAGE_MAX_SIZE' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-12">

              </div>
            </div>
            <div class="d-flex justify-content-end buttons-section">
              <button (click)="toggleSingleSOP()" class="btn-cancel-bordered-bd separate-buttons">{{
                'AUTHORIZATION.CANCEL' | translate }}</button>
              <button (click)="upload(file)" *ngIf="imageId == null" class="btn btn-continue-bordered-bd">{{
                translationKeys.Authorization.Save | translate }}</button>
              <button class="btn btn-cancel-bordered-bd separate-buttons" *ngIf="imageId != null"
                (click)="openDeleteModal(delmodal);">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
              <button (click)="updateImage(file)" *ngIf="imageId != null" class="btn btn-continue-bordered-bd">{{
                translationKeys.Observation.Update | translate }}</button>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>


<ng-template #delmodal>
  <div class="modal-header bhp-modal-header">
    <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body bhp-modal-body">
    <p class="">
      {{ 'SOP_MANAGEMENT.CONFIRMATION_DELETE_IMAGE' | translate }}
    </p>
  </div>
  <div class="modal-footer bhp-modal-footer">
    <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
    <button (click)="removeImage();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
  </div>
</ng-template>